module.exports = __webpack_public_path__ + "img/ntc1009-mens-silk-top-toupee-2-300x300.8559789e.jpg";